import PageLoadable from 'components/modules/Loadable/PageLoadable';

const AsyncNotFound = PageLoadable({ loader: () => import('./NotFound') });
const AsyncLogin = PageLoadable({ loader: () => import('./Login') });
// const AsyncRegister = PageLoadable({ loader: () => import('./Register') });
const AsyncResetPassword = PageLoadable({ loader: () => import('./ResetPassword') });
// const AsyncNotifications = PageLoadable({ loader: () => import('./Notifications') });
const AsyncMaintenance = PageLoadable({ loader: () => import('./Maintenance') });
const AsyncInitialRoute = PageLoadable({ loader: () => import('./InitialRoute') });
const AsyncLoginPassword = PageLoadable({ loader: () => import('./LoginPassword') });
const AsyncLoginEmail = PageLoadable({ loader: () => import('./LoginEmail') });
const AsyncDashboard = PageLoadable({ loader: () => import('./Dashboard') });
const AsyncModerateSubCategory = PageLoadable({ loader: () => import('./ModerateSubCategory') });
const AsyncCategories = PageLoadable({ loader: () => import('./Categories') });
const AsyncSubCategories = PageLoadable({ loader: () => import('./SubCategories') });
const AsyncProviders = PageLoadable({ loader: () => import('./Providers') });
const AsyncModerateCategory = PageLoadable({ loader: () => import('./ModerateCategory') });
const AsyncModerateProviders = PageLoadable({ loader: () => import('./ModerateProviders') });
const AsyncCategory = PageLoadable({ loader: () => import('./Category') });
const AsyncEmergencySupport = PageLoadable({ loader: () => import('./EmergencySupport') });
const AsyncRegionalFocusDataInformation = PageLoadable({
    loader: () => import('./RegionalFocusDataInformation'),
});
const AsyncRegionalFocusDataInformationPostCode = PageLoadable({
    loader: () => import('./RegionalFocusDataInformationPostCode'),
});
const AsyncQuestions = PageLoadable({ loader: () => import('./Questions') });
const AsyncSummary = PageLoadable({ loader: () => import('./Summary') });
const AsyncPathwayComplete = PageLoadable({ loader: () => import('./PathwayComplete') });
const AsyncServiceDetails = PageLoadable({ loader: () => import('./ServiceDetails') });
const AsyncConfirmationID = PageLoadable({ loader: () => import('./ConfirmationID') });
const AsyncUtilityBill = PageLoadable({ loader: () => import('./UtilityBill') });
const AsyncSubCategoryProviderQuestions = PageLoadable({
    loader: () => import('./SubCategoryProviderQuestions'),
});
const AsyncSubCategory = PageLoadable({ loader: () => import('./SubCategory') });
const AsyncGroups = PageLoadable({ loader: () => import('./Groups') });
const AsyncModerateGroups = PageLoadable({ loader: () => import('./ModerateGroups') });
const AsyncCostOfLivings = PageLoadable({ loader: () => import('./CostOfLivings') });
const AsyncManageEmergencySupport = PageLoadable({
    loader: () => import('./ManageEmergencySupport'),
});
const AsyncParentCategory = PageLoadable({ loader: () => import('./ParentCategory') });
const AsyncCompleteSurvey = PageLoadable({ loader: () => import('./CompleteSurvey') });
const AsyncPathwayQuestions = PageLoadable({ loader: () => import('./PathwayQuestions') });
const AsyncModeratePathwayQuestion = PageLoadable({
    loader: () => import('./ModeratePathwayQuestion'),
});
const AsyncQualifyingCriteria = PageLoadable({ loader: () => import('./QualifyingCriteria') });
const AsyncModerateQualifyingCriteria = PageLoadable({
    loader: () => import('./ModerateQualifyingCriteria'),
});
const AsyncIntroduction = PageLoadable({ loader: () => import('./Introduction') });
const AsyncAboutYou = PageLoadable({ loader: () => import('./AboutYou') });
const AsyncConfirmEmail = PageLoadable({ loader: () => import('./ConfirmEmail') });
const AsyncServiceStatus = PageLoadable({ loader: () => import('./ServiceStatus') });
const AsyncWhichService = PageLoadable({ loader: () => import('./WhichService') });
const AsyncRelationship = PageLoadable({ loader: () => import('./Relationship') });
const AsyncQuestionsFinished = PageLoadable({ loader: () => import('./QuestionsFinished') });
const AsyncAdditionalInfo = PageLoadable({ loader: () => import('./AdditionalInfo') });
const AsyncAdditionalInfoOptions = PageLoadable({
    loader: () => import('./AdditionalInfoOptions'),
});
const AsyncCongratulations = PageLoadable({ loader: () => import('./Congratulations') });
const AsyncProofOfService = PageLoadable({ loader: () => import('./ProofOfService') });
const AsyncProofOfServiceInfo = PageLoadable({ loader: () => import('./ProofOfServiceInfo') });
const AsyncFinancialSupportChecklist = PageLoadable({
    loader: () => import('./FinancialSupportChecklist'),
});
const AsyncFinancialSupportChecklistInfo = PageLoadable({
    loader: () => import('./FinancialSupportChecklistInfo'),
});
const AsyncHelpNextSteps = PageLoadable({ loader: () => import('./HelpNextSteps') });
const AsyncMembers = PageLoadable({ loader: () => import('./Members') });
const AsyncSubgroups = PageLoadable({ loader: () => import('./Subgroups') });
const AsyncStart = PageLoadable({ loader: () => import('./Start') });
const AsyncWelfareCases = PageLoadable({ loader: () => import('./WelfareCases') });
const AsyncFeedback = PageLoadable({ loader: () => import('./Feedback') });
const AsyncCategorySubCategoryConfirmation = PageLoadable({
    loader: () => import('./CategorySubCategoryConfirmation'),
});
const AsyncMemberCompletedWithCases = PageLoadable({
    loader: () => import('./MemberCompletedWithCases'),
});
const AsyncAdminManagement = PageLoadable({ loader: () => import('./AdminManagement') });
// ROUTE IMPORT CODE GENERATOR INDICATOR DO NOT DELETE

const routes = {
    LOGIN_EMAIL: {
        component: AsyncLoginEmail,
        path: '/login/email',
        authedRoute: false,
    },
    LOGIN_PASSWORD: {
        component: AsyncLoginPassword,
        path: '/login/password',
        authedRoute: false,
    },
    LOGIN: {
        component: AsyncLogin,
        path: '/login',
        authedRoute: false,
    },
    // REGISTER: {
    //     component: AsyncRegister,
    //     path: '/register',
    //     authedRoute: false
    // },
    RESET_PASSWORD: {
        component: AsyncResetPassword,
        path: '/reset-password',
        authedRoute: false,
    },
    // NOTIFICATIONS: {
    //     component: AsyncNotifications,
    //     path: '/notifications',
    //     authedRoute: true
    // },
    MAINTENANCE: {
        component: AsyncMaintenance,
        path: '/maintenance',
        authedRoute: false,
    },
    DASHBOARD: {
        component: AsyncDashboard,
        path: '/dashboard',
        authedRoute: true,
    },
    MODERATE_SUB_CATEGORY: {
        component: AsyncModerateSubCategory,
        path: '/moderate-sub-categories',
        authedRoute: true,
    },
    CATEGORIES: {
        component: AsyncCategories,
        path: '/categories',
        authedRoute: true,
    },
    SUB_CATEGORIES: {
        component: AsyncSubCategories,
        path: '/sub-categories',
        authedRoute: true,
    },
    PROVIDERS: {
        component: AsyncProviders,
        path: '/providers',
        authedRoute: true,
    },
    MODERATE_CATEGORY: {
        component: AsyncModerateCategory,
        path: '/moderate-categories',
        authedRoute: true,
    },
    MODERATE_PROVIDERS: {
        component: AsyncModerateProviders,
        path: '/moderate-providers',
        authedRoute: true,
    },
    CATEGORY: {
        component: AsyncCategory,
        path: '/:application_id/:user_id/:case_id/category',
        authedRoute: false,
    },
    EMERGENCY_SUPPORT: {
        component: AsyncEmergencySupport,
        path: '/:application_id/:user_id/:case_id/emergency-support',
        authedRoute: false,
    },
    REGIONAL_FOCUS_DATA_INFORMATION: {
        component: AsyncRegionalFocusDataInformation,
        path: '/:application_id/:user_id/:case_id/regional-information',
        authedRoute: false,
    },
    REGIONAL_FOCUS_DATA_INFORMATION_POST_CODE: {
        component: AsyncRegionalFocusDataInformationPostCode,
        path: '/:application_id/:user_id/:case_id/regional-information-postcode',
        authedRoute: false,
    },
    QUESTIONS: {
        component: AsyncQuestions,
        path: '/:application_id/:user_id/:case_id/question/:page',
        authedRoute: false,
    },
    SUMMARY: {
        component: AsyncSummary,
        path: '/:application_id/:user_id/:case_id/summary',
        authedRoute: false,
    },
    PATHWAY_COMPLETE: {
        component: AsyncPathwayComplete,
        path: '/:application_id/:user_id/:case_id/complete-pathway',
        authedRoute: false,
    },
    SERVICE_DETAILS: {
        component: AsyncServiceDetails,
        path: '/:application_id/:user_id/:case_id/service-details',
        authedRoute: false,
    },
    CONFIRMATION_I_D: {
        component: AsyncConfirmationID,
        path: '/:application_id/:user_id/:case_id/confirm-id',
        authedRoute: false,
    },
    UTILITY_BILL: {
        component: AsyncUtilityBill,
        path: '/:application_id/:user_id/:case_id/utility-bill',
        authedRoute: false,
    },
    SUB_CATEGORY_PROVIDER_QUESTIONS: {
        component: AsyncSubCategoryProviderQuestions,
        path: '/questions',
        authedRoute: true,
    },
    SUB_CATEGORY: {
        component: AsyncSubCategory,
        path: '/:application_id/:user_id/:case_id/sub-category',
        authedRoute: false,
    },
    GROUPS: {
        component: AsyncGroups,
        path: '/groups',
        authedRoute: true,
    },
    MODERATE_GROUPS: {
        component: AsyncModerateGroups,
        path: '/moderate-groups',
        authedRoute: true,
    },
    COST_OF_LIVINGS: {
        component: AsyncCostOfLivings,
        path: '/cost-of-living',
        authedRoute: true,
    },
    MANAGE_EMERGENCY_SUPPORT: {
        component: AsyncManageEmergencySupport,
        path: '/manage-emergency-support',
        authedRoute: true,
    },
    PARENT_CATEGORY: {
        component: AsyncParentCategory,
        path: '/:application_id/:user_id/:case_id/parent-category',
        authedRoute: false,
    },
    COMPLETE_SURVEY: {
        component: AsyncCompleteSurvey,
        path: '/:application_id/:user_id/questionnaire-completed',
        authedRoute: false,
    },
    PATHWAY_QUESTIONS: {
        component: AsyncPathwayQuestions,
        path: '/pathway-questions',
        authedRoute: true,
    },
    MODERATE_PATHWAY_QUESTION: {
        component: AsyncModeratePathwayQuestion,
        path: '/moderate-pathway-question',
        authedRoute: true,
    },
    QUALIFIER_QUESTIONS: {
        component: AsyncQualifyingCriteria,
        path: '/qualifying-criteria',
        authedRoute: true,
    },
    MODERATE__QUALIFIERQUESTION: {
        component: AsyncModerateQualifyingCriteria,
        path: '/moderate-qualifying-criteria',
        authedRoute: true,
    },
    INTRODUCTION: {
        component: AsyncIntroduction,
        path: '/:application_id/:user_id/:case_id/introduction',
        authedRoute: false,
    },
    ABOUT_YOU: {
        component: AsyncAboutYou,
        path: '/:application_id/:user_id/:case_id/about-you',
        authedRoute: false,
    },
    CONFIRM_EMAIL: {
        component: AsyncConfirmEmail,
        path: '/:application_id/:user_id/:case_id/confirm-email',
        authedRoute: false,
    },
    SERVICE_STATUS: {
        component: AsyncServiceStatus,
        path: '/:application_id/:user_id/:case_id/service-status',
        authedRoute: false,
    },
    WHICH_SERVICE: {
        component: AsyncWhichService,
        path: '/:application_id/:user_id/:case_id/which-service',
        authedRoute: false,
    },
    RELATIONSHIP: {
        component: AsyncRelationship,
        path: '/:application_id/:user_id/:case_id/relationship',
        authedRoute: false,
    },
    QUESTIONS_FINISHED: {
        component: AsyncQuestionsFinished,
        path: '/:application_id/:user_id/:case_id/finished',
        authedRoute: false,
    },
    ADDITIONAL_INFO: {
        component: AsyncAdditionalInfo,
        path: '/:application_id/:user_id/:case_id/additional-info',
        authedRoute: false,
    },
    ADDITIONAL_INFO_OPTIONS: {
        component: AsyncAdditionalInfoOptions,
        path: '/:application_id/:user_id/:case_id/additional-info-options',
        authedRoute: false,
    },
    CONGRATULATIONS: {
        component: AsyncCongratulations,
        path: '/:application_id/:user_id/:case_id/congratulations',
        authedRoute: false,
    },
    PROOF_OF_SERVICE: {
        component: AsyncProofOfService,
        path: '/:application_id/:user_id/:case_id/proof-of-service',
        authedRoute: false,
    },
    PROOF_OF_SERVICE_INFO: {
        component: AsyncProofOfServiceInfo,
        path: '/:application_id/:user_id/:case_id/proof-of-service-info',
        authedRoute: false,
    },
    FINANCIAL_SUPPORT_CHECKLIST: {
        component: AsyncFinancialSupportChecklist,
        path: '/:application_id/:user_id/:case_id/financial-support-checklist',
        authedRoute: false,
    },
    FINANCIAL_SUPPORT_CHECKLIST_INFO: {
        component: AsyncFinancialSupportChecklistInfo,
        path: '/:application_id/:user_id/:case_id/financial-support-checklist-info',
        authedRoute: false,
    },
    HELP_NEXT_STEPS: {
        component: AsyncHelpNextSteps,
        path: '/:application_id/:user_id/:case_id/help-next-steps',
        authedRoute: false,
    },
    MEMBERS: {
        component: AsyncMembers,
        path: '/members',
        authedRoute: true,
    },
    SUBGROUPS: {
        component: AsyncSubgroups,
        path: '/subgroups',
        authedRoute: true,
    },
    START: {
        component: AsyncStart,
        path: '/start',
        authedRoute: true,
    },
    WELFARE_CASES: {
        component: AsyncWelfareCases,
        path: '/welfare-cases',
        authedRoute: true,
    },
    CATEGORY_SUB_CATEGORY_CONFIRMATION: {
        component: AsyncCategorySubCategoryConfirmation,
        path: '/:application_id/:user_id/:case_id/category-sub-category-confirmation',
        authedRoute: false,
    },
    MEMBER__COMPLETED_WITHCASES: {
        component: AsyncMemberCompletedWithCases,
        path: '/:application_id/:user_id/cases',
        authedRoute: false,
    },
    ADMIN_MANAGEMENT: {
        component: AsyncAdminManagement,
        path: '/admin-management',
        authedRoute: true,
    },
    FEEDBACK: {
        component: AsyncFeedback,
        path: '/feedback',
        authedRoute: true,
    },
    // ROUTE ENTRY CODE GENERATOR INDICATOR DO NOT DELETE
    INITIAL_ROUTE: {
        component: AsyncInitialRoute,
        path: '/',
        authedRoute: false,
    },
    NOT_FOUND: {
        component: AsyncNotFound,
        path: '*',
        authedRoute: false,
    },
};

export default routes;
